module.exports = function getResource(label, vars = []) {
    const resources = {
        searchResults: 'Search Results',
        sale: 'Sale',
        resultsFor: `${vars[0]} results for *${vars[1]}*`
    };

    return resources[label];
};
